import React from 'react';
import styled from 'styled-components';
import MoogulIcon from './MoogulIcon';

const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${props => props.theme.colors.secondary};
  padding: 0px 0px;
  border-radius: 100px;
  margin-bottom: ${props => props.$mb || '32px'};
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

const TagIcon = styled(MoogulIcon)`
  color: ${props => props.theme.colors.secondary};
`;

const Tag = ({ children, icon = true, mb, className, ...props }) => {
  return (
    <TagWrapper $mb={mb} className={className} {...props}>
      {icon && <TagIcon size="1rem" />}
      {children}
    </TagWrapper>
  );
};

export default Tag; 